module.exports = __webpack_public_path__ + "img/installAndroid2.c585a2ba.png";